import { Points, Vector3 } from 'three';

import { renderOrders } from '../../../../../viewer/render-orders';
import { loadLasPoints } from './load-las-points';

async function loadSparsePointCloud(url: string, origo: Vector3): Promise<Points> {
  const points = await loadLasPoints(url, origo);
  points.renderOrder = renderOrders.aligner.sparseCloud;
  return points;
}

export const classicDataLoaders = {
  loadSparsePointCloud,
};
